import { useContext } from 'react'
import AuthorizationContext from './AuthorizationProvider.context'

/**
 * The authorization custom hook.
 */
export const useAuthorization = () => {
  const { isBuyer, isSeller, isPrivate, userType } = useContext(AuthorizationContext)

  return { isBuyer, isPrivate, isSeller, userType }
}
